import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function WhatsAppButton({ full = false }) {
  const { t } = useApp();
  const [number, setNumber] = useState("");
  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setNumber(data.whatsapp_number || "")).catch(() => {});
  }, []);
  const href = number ? `https://wa.me/${number.replace(/[^0-9]/g, "")}` : "#";
  return (
    <a
      data-testid="whatsapp-message-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn-ghost inline-flex items-center justify-center gap-2.5 px-6 py-3 text-xs ${full ? "w-full" : ""}`}
    >
      <MessageCircle size={16} />
      {t("message_us")}
    </a>
  );
}
